import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfigureColumns from "../../../Core/ConfigureColumns/ConfigureColumns";
import ExportCSV from '../../../Core/Export/ExportCSV'
import ActionButtonDropdown from "../../../Components/ActionButtonDropdown";
import ListLayout from "../../../Core/Layout/ListLayout";
import SearchFilters from "../../../Core/SearchFilters/SearchFilters";
import Table from "../../../Core/Table/Table";
import Pagination from "../../../Core/Pagination/Pagination";
import Tabs from "../../../Components/Tabs";
import { useGetListWmsMutation } from "../../../store/api/settingapi";
import { useGetSelectedCompanyQuery } from "../../../store/api/companyapi";
import useScreenHeight from "../../../utils/useScreenHeight";


const MainContent = () => {
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(12);
    const { screenHeight, screenScaling } = useScreenHeight();

    useEffect(() => {
        console.log(
            "DEBUG → screenHeight:",
            screenHeight,
            "screenScaling:",
            screenScaling
        );
        if (screenHeight === null || screenScaling === null) return;
        let count;

        // Small screens
        if (screenHeight < 600) {
            count = 5;
        } else if (screenHeight < 622 && screenScaling === 1.5) {
            count = 10;
        } else if (screenHeight < 767 && screenScaling === 1.25) {
            count = 12;
        } else if (screenHeight < 981 && screenScaling === 1) {
            count = 20;
        }
        // Fallback for 600–979 range (you had no rule for this!)
        else {
            count = 12; // or define your own logic here
        }
        console.log(
            "DEBUG → screenHeight:",
            screenHeight,
            "screenScaling:",
            screenScaling
        );
        console.log(
            "%c[FINAL DECISION] → Setting page size to:",
            "color: green; font-weight: bold",
            count
        );
        setPageSize(count);
    }, [screenHeight, screenScaling]);
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [settingList, setsettingList] = useState([]);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [settingApi] = useGetListWmsMutation();
    const { data,isLoading } = useGetSelectedCompanyQuery();
    const selectedComapny = data?.message?.data?.company;
    console.log("selectedComapny",selectedComapny);
    const filtersConfig = [
    { name: 'link_company', label: 'Company', width: '15%' },
    { name: 'name', label: 'Name', width: '15%' },
    {
        name: 'packing_slip_required',
        label: 'Packing Slip Required',
        width: '12%',
    },
    {
        name: 'gate_entry',
        label: 'Gate Entry',
        width: '10%',
    },
    {
        name: 'enable_asn',
        label: 'Enable ASN',
        width: '10%',
    },
    { name: 'modified', label: 'Last Modified', type: 'date', width: '15%' },
    ];

    const columns = [
        {
            header: "SI No.",
            name: "SI No.",
            accessor: "id",
            width: '7%',
            cellRenderer: (row, rowIndex) => rowIndex + 1 + (pageSize * (currentPage - 1)),
            sortable: false
        },
        {
            header: "Company",
            name: "Company",
            accessor: "link_company",
            width: '15%',
            sortable: true
        },
        {
            header: "Name",
            name: "Name",
            accessor: "name",
            width: '15%',
            sortable: true
        },
        {
            header: "Packing Slip Required",
            name: "Packing Slip Required",
            accessor: "packing_slip_required",
            width: '12%',
            sortable: true,
            cellRenderer: (row) => row.packing_slip_required ? 'Yes' : 'No'
        },
        {
            header: "Gate Entry",
            name: "Gate Entry",
            accessor: "gate_entry",
            width: '10%',
            sortable: true,
            cellRenderer: (row) => row.gate_entry ? 'Yes' : 'No'
        },
        {
            header: "Enable ASN",
            name: "Enable ASN",
            accessor: "enable_asn",
            width: '10%',
            sortable: true,
            cellRenderer: (row) => row.enable_asn ? 'Yes' : 'No'
        },
        {
            header: "Default Purchase Bin",
            name: "Default Purchase Bin",
            accessor: "default_purchase_bin",
            width: '12%',
            sortable: true
        },
        {
            header: "Last Modified",
            name: "Last Modified",
            accessor: "modified",
            width: '12%',
            sortable: true,
            cellRenderer: (row) => new Date(row.modified).toLocaleDateString()
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            )
        },
    ];
 
    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };
    const handleView = (id) => {
        try {
            navigate(`/setting/view-setting`, { state: { Company: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };
    const handleEdit = async (id) => {
        try {
            navigate(`/setting/edit-setting`, { state: { Company: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };
    const handleDelete = (id) => {
        console.log("Delete logic for ID:", id);
    };

    const actionButtons = [
        {
            className: "custom-btn-00989 d-flex",
            to: "/setting/create-setting",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add WMS Setting"
        }
    ];

    const [selectedColumns, setSelectedColumns] = useState([]);
    const handleSaveColumns = (selectedFields) => {
        setSelectedColumns(selectedFields);
    };

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            try {
                const filteredSearchInput = Object.entries(filters).reduce((acc, [key, value]) => {
                    if (value !== '' && value !== undefined && value !== null) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                const payload = {
                    start: pageSize * (currentPage - 1),
                    page_length: pageSize,
                    search_input: {
        link_company: selectedComapny.split(" - ")[0],
        ...(Object.keys(filteredSearchInput).length > 0 && filteredSearchInput)
    }
                };

                const response = await settingApi(payload);
                setsettingList(response.data.result)     
            } catch (error) {
                console.error("Error fetching purchase orders:", error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [currentPage, filters, settingApi,isLoading, pageSize]);

    return (
        <div className="container-fluid d-flex flex-column " style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "WMS Setting" },
                    { label: "WMS Setting List", style: { color: '#391F84' } }
                ]}
                actionButtons={actionButtons}
            >
                <SearchFilters
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterChange}
                    onSettingsToggle={() => setShowColumnConfig(true)}
                />
                <Table
                    columns={columns}
                    data={settingList.records}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={settingList.total_count}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {showExportPopup && (
                    <ExportCSV
                        doctype="Purchase Order"
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>


            <ConfigureColumns
                show={showColumnConfig}
                onClose={() => setShowColumnConfig(false)}
                onSave={handleSaveColumns}
                docType="Purchase Order"
                defaultSelected={columns}
            />

        </div>
    );
};

export default MainContent;